import React from "react";

import formatCurrency from "utils/formatCurrency";

const descriptionText = (data) => data.description;

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const [red, green, blue, gray] = ["#FF8B89", "#60C8B1", "#289EFC", "#cbd5e0"];

const computeColumns = (belowMd) =>
  (belowMd
    ? [
      {
        Header: "Description",
        accessor: (data) => (
          <div className="flex items-center leading-tight">
            <div
              className={`flex flex-col items-center mr-2 text-sm md:text-base md:mr-0 border-r border-gray-200 pr-2 
                  ${data.returned_at ? "" : "text-gray-500"}`}
            >
              <div>{months[new Date(data.created_at).getMonth()]}</div>
              <div>{new Date(data.created_at).getDate()}</div>
            </div>
            <div className="flex-1">
              <div>
                {data.disputed ? (
                  <i className="fas fa-exclamation-triangle text-red-500 mr-2 text-sm" />
                ) : (
                  <></>
                )}
                {descriptionText(data)}
              </div>
              <div
                className={`${data.returned_at ? "" : "text-gray-500"} 
                    text-sm md:text-base`}
              >
                {data.category ||
                    (`${data.amount || ""}`.startsWith("-") ? "credit" : "")}
              </div>
            </div>
          </div>
        ),
      },
      {
        Header: "Amount",
        accessor: (data) =>
          `${data.amount ? formatCurrency(data.amount) : ""}`,
        Cell: (data) => {
          const t = (data.row.original.type || "").toLowerCase();
          const c = (data.row.original.category || "").toLowerCase();
          const a = `${data.row.original.amount || ""}`;
          const s = `${data.row.original.status || ""}`.toLowerCase();
          return (
            <div
              style={{
                color: (() => {
                  if (t === "payment") {
                    return data.row.original.returned_at ? "" : green;
                  }
                  if (t === "refund" || c === "refund" || a.startsWith("-")) { return blue; }
                  if (s === "disputed") { return gray; }
                  return "";
                })(),
              }}
            >
              <div>
                {`${data.row.original.returned_at ? "Failed/Returned " : ""}${
                  data.row.values.Amount
                }`}
              </div>
              {s === "pending" ? (
                <div className="font-normal text-gray-600 text-xxs -mt-1 -mb-1">
                    pending
                </div>
              ) : s === "canceled" ? (
                <div style={{ color: red }} className="font-normal text-xxs">
                    canceled
                </div>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
    ]
    : [
      {
        Header: "Date",
        accessor: (data) => new Date(data.created_at),
        Cell: ({ value }) =>
          value.toLocaleString("en-US", {
            dateStyle: "medium",
          }),
        // accessor: 'timestamp'
      },
      {
        Header: "Description",
        accessor: (data) => (
          <div>
            {data.disputed ? (
              <i className="fas fa-exclamation-triangle text-red-500 mr-2 text-sm" />
            ) : (
              <></>
            )}
            {descriptionText(data)}
          </div>
        ),
      },
      {
        Header: "Category",
        accessor: (data) => {
          if (`${data.amount || ""}`.startsWith("-")) { return data.category || "credit"; }
          return data.category || "";
        },
      },
      {
        Header: "Amount",
        accessor: (data) =>
          `${data.amount ? formatCurrency(data.amount.toFixed(2)) : ""}`,
        Cell: (data) => {
          const t = (data.row.original.type || "").toLowerCase();
          const c = (data.row.original.category || "").toLowerCase();
          const a = `${data.row.original.amount || ""}`;
          const s = `${data.row.original.status || ""}`.toLocaleLowerCase();
          return (
            <div
              style={{
                color: (() => {
                  if (t === "payment") {
                    if (data.row.original.returned_at) {
                      return "";
                    }
                    return green;
                  }
                  if (t === "refund" || c === "refund" || a.startsWith("-")) { return blue; }
                  if (s === "disputed") { return gray; }
                  return "";
                })(),
              }}
            >
              <div className="flex justify-between">
                <span>{`${
                  data.row.original.returned_at ? "Failed/Returned " : ""
                }`}</span>
                <span>{data.row.values.Amount}</span>
              </div>
              {s === "pending" ? (
                <div className="font-normal text-gray-600 text-xxs -mt-1 -mb-1">
                    pending
                </div>
              ) : s === "canceled" ? (
                <div
                  style={{ color: "#FF8B89" }}
                  className="font-normal text-xxs"
                >
                    canceled
                </div>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
    ]);

export default computeColumns;
